import React from "react";
import { Link } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
const shipNamesById = [{ 1: "ZIM" }, { 2: "Ems" }];
const cameraNamesById = { 1: "Engine Room" };

const DynamicShipBreadcrumb = ({ match }) => {
  console.log(match);

  return <span>{shipNamesById.map((i) => i[match.params.shipId])}</span>;
};
const DynamicCameraBreadcrumb = ({ match }) => {
  console.log(match);
  return <span>{cameraNamesById[match.params.cameraId]}</span>;
};
const routes = [
  { path: "/ships/:shipId", breadcrumb: DynamicShipBreadcrumb },
  { path: "/", breadcrumb: "خانه" },
  { path: "/coursedash", breadcrumb: "بوت کمپ های من " },
  { path: "/studentcourse", breadcrumb: "داشبورد" },
  { path: "/studentcourse/bootcamp", breadcrumb: "بوت کمپ های من " },
  { path: "/studentcourse/idea", breadcrumb: "ایده ها" },
  { path: "/studentcourse/priority", breadcrumb: "اولویت ها" },
  { path: "/studentcourse/meeting", breadcrumb: "جلسات" },
  { path: "/studentcourse/myteam", breadcrumb: "تیم من" },
  { path: "/studentcourse/files", breadcrumb: "فایل ها" },
  { path: "/studentcourse/poll", breadcrumb: "نظرسنجی" },
  { path: "/studentcourse/message", breadcrumb: "پیام های بوت کمپ" },
  { path: "/coursedash/generalinfo", breadcrumb: "اطلاعات کلی بوت کمپ" },
  { path: "/coursedash/sections", breadcrumb: "جلسات" },
  { path: "/coursedash/tickets", breadcrumb: "بلیت ها" },
  { path: "/coursedash/off", breadcrumb: "کد تخفیف" },
  { path: "/coursedash/idea", breadcrumb: "ایده ها" },
  { path: "/coursedash/Priority", breadcrumb: "اولویت‌ها" },
  { path: "/coursedash/roles", breadcrumb: "مدیریت نقش ها" },
  { path: "/coursedash/teams", breadcrumb: "تیم ها" },
  { path: "/coursedash/file", breadcrumb: "فایل ها" },
  { path: "/coursedash/survey", breadcrumb: "نظرسنجی" },
  { path: "/coursedash/document", breadcrumb: "مدارک" },
  { path: "/coursedash/arbitration", breadcrumb: "داوری" },
  { path: "/coursedash/adminmessage", breadcrumb: "پیام های بوت کمپ" },
  { path: "/coursedash/Priority", breadcrumb: "اولویت ها" },
  { path: "/dashboard", breadcrumb: "داشبورد ادمین" },
  { path: "/dashboard/bootcamps", breadcrumb: "بوت کمپ های ساخته شده" },
  { path: "/dashboard/profile", breadcrumb: "پروفایل" },
  { path: "/dashboard/finance", breadcrumb: "امور مالی" },
  { path: "/dashboard/sponsors", breadcrumb: "حامیان و برگزارکنندگان" },
  { path: "/dashboard/Support-ticket", breadcrumb: "تیکت پشتیبانی" },
  { path: "/dashboard/Systemnotifications", breadcrumb: "اعلانات سیستمی" },
  { path: "/studentdashboard", breadcrumb: "داشبورد" },
  { path: "/studentdashboard/bootcamp", breadcrumb: "بوت کمپ های من" },
  {
    path: "/studentdashboard/savebootcamp",
    breadcrumb: "بوت کمپ های ذخیره شده",
  },
  { path: "/studentdashboard/finance", breadcrumb: "امور مالی" },
  { path: "/studentdashboard/profile", breadcrumb: "پروفایل" },
  { path: "/studentdashboard/supportticket", breadcrumb: "تیکت پشتیبانی" },
  {
    path: "/studentdashboard/Systemnotifications",
    breadcrumb: "اعلانات سیستمی",
  },
  {
    path: "/ships/:shipId/cameras/:cameraId",
    breadcrumb: DynamicCameraBreadcrumb,
  },
];

const Breadcrumb = () => {
  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <div className="breadcrumbs flex flex-row items-center justify-start">
      {breadcrumbs.map(({ breadcrumb, match }, index) => (
        <div className="bc" key={match.url}>
          <Link
            to={match.url || ""}
            className={
              index === breadcrumbs.length - 1
                ? "text-[#000000] font-normal text-[1rem] leading-[1.5rem] "
                : `text-[#71717199] font-normal text-[1rem] leading-[1.5rem] ml-[0.8rem]`
            }
          >
            {breadcrumb}
          </Link>
          <span className=" ml-[0.4rem]">
            {index < breadcrumbs.length - 1 && ">"}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
